// Version simple du SplashScreen
import React, { useEffect } from "react";

// Composant fonction avec hook pour forcer le masquage
const SplashScreen = (props) => {
  // Accès à l'erreur via props plutôt que destructuring
  const error = props.error;

  // Recharger la page en cas d'erreur
  function handleForceReload() {
    window.location.reload();
  }
  
  // Hook pour assurer que le splash screen disparaît après un certain temps
  useEffect(() => {
    const forceHideTimeout = setTimeout(() => {
      // Force la disparition même si l'initialisation est bloquée
      const splash = document.getElementById('splash-screen');
      if (splash) {
        console.log("Force masquage du splash screen via DOM");
        splash.style.display = 'none';
      }
      
      // Masquer via localStorage pour les autres composants
      localStorage.setItem('splashHidden', 'true');
      
      // Essayer de forcer le contexte aussi (si possible)
      if (window.__APP_CONTEXT && typeof window.__APP_CONTEXT.hideSplash === 'function') {
        window.__APP_CONTEXT.hideSplash();
      }
    }, 6000); // 6 secondes maximum
    
    return () => clearTimeout(forceHideTimeout);
  }, []);

  // Rendu du composant
  return (
    <div id="splash-screen" className="fixed inset-0 flex items-center justify-center bg-black z-[99999]">
      <div className="text-center p-6 max-w-sm mx-auto">
        <div className="w-16 h-16 border-4 border-t-blue-500 border-white rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-white text-lg">
          Chargement de l'application Kappela...
        </p>
        
        {error && (
          <div className="mt-6 bg-red-900/50 p-4 rounded-lg border border-red-600">
            <p className="text-red-200 text-sm">
              {typeof error === 'string' 
                ? error 
                : "Une erreur s'est produite lors du chargement. Veuillez réessayer."}
            </p>
            <button 
              className="mt-3 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
              onClick={handleForceReload}
            >
              Réessayer
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Export par défaut
export default SplashScreen;